import { render, staticRenderFns } from "./Personal-Info.vue?vue&type=template&id=6e0d580d&"
import script from "./Personal-Info.vue?vue&type=script&lang=js&"
export * from "./Personal-Info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports